var forgotPwdCtrl = function (restSvc, ifacsSvc, $location, loginLocation, forgotPwdConstant) {
    "use strict";

    this.restSvc = restSvc;
    this.ifacsSvc = ifacsSvc;
    this.location = $location;
    this.loginLocation = loginLocation;
    this.forgotPwdConstant = forgotPwdConstant;

    this.onLoad();
};

forgotPwdCtrl.prototype.onLoad = function () {
    "use strict";

    this.onUsernameEmailChange();

    var clientCd = this.loginLocation.clientCd();
    var rest = this.restSvc.query({type: "configuration", method: "retrieveForgotPwdSetting"}, {"clientCd" : clientCd});
    rest.$promise.then(this.pass(this),this.fail);
};

forgotPwdCtrl.prototype.pass = function (controller){
    "use strict";
    return function (result) {
        controller.userAdminSettingMap = result.userAdminSettingMap;
    };

};

forgotPwdCtrl.prototype.onSubmit = function () {
    "use strict";

    var langCd = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
    langCd = langCd.substr(0,2);
    this.isForgotPwdSubmitted = false;

    this.ifacsSvc.forgotPwd({ method:"forgot_pwd"},
        {"j_username" : this[this.forgotPwdConstant.JUSERNAME],
            language: langCd,
            email : this.email
        })
        .$promise.then(this.success(this));
};

forgotPwdCtrl.prototype.success = function (controller) {
    "use strict";

    window.console.log("Forgot password request is submitted.");

    return function(response) {
        var responseCode = response.code;
        window.console.log("Response from ifacs:" + responseCode);
        controller.isForgotPwdSubmitted = true;
        if ("SUCCESS" === responseCode) {
            controller.isForgotPwdResponseOk = true;
        } else {
            controller.isForgotPwdResponseOk = false;
        }
    };
};

forgotPwdCtrl.prototype.onCancel = function () {
 "use strict";
  var url=window.location.href;
  var ifstwbprinUrlIndex=url.indexOf('ifastweb');  
  var secondPart,firstPart,redirectUrl;
  if(ifstwbprinUrlIndex > 0){
    secondPart= "ifastweb/login.html#!/login";
	firstPart= url.substring(0,url.indexOf("ifastweb"));
	redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }else{
    secondPart= "/login.html#!/login";
	firstPart= url.substring(0,url.indexOf("/login.html"));
	redirectUrl=firstPart+secondPart;
    window.location.href=redirectUrl
  }
};

forgotPwdCtrl.prototype.onUsernameEmailChange = function () {
    "use strict";

    if (null !== this[this.forgotPwdConstant.JUSERNAME] && undefined !== this[this.forgotPwdConstant.JUSERNAME] &&
        0 < this[this.forgotPwdConstant.JUSERNAME].trim().length && null !== this.email && undefined !== this.email && 0 < this.email.trim().length) {
        this.disableSubmit = false;
    } else {
        this.disableSubmit = true;
    }
};

forgotPwdCtrl.$inject = ["restSvc", "ifacsSvc", "$location", "loginLocation","forgotPwdConstant"];
angular.module("iFAST.login")
    .constant("forgotPwdConstant",{
        "JUSERNAME": "j_username",
        "JPASSWORD": "j_password",
        "NEWPASSWORD": "new_password",
        "CONFPASSWORD": "conf_password"
    })
    .controller("forgotPwdCtrl", forgotPwdCtrl);


// WEBPACK FOOTER //
// ./WebContent/src/login/forgotPwd-controller.js